import type { ReactNode } from 'react'
import { Header } from './Header'
import { BottomNav } from './BottomNav'
import { usePromoAlerts } from '@/hooks'
import { useRefreshOnFocus } from '@/hooks/useRefreshOnFocus'
import { PromoAlertBanner } from '@/components/dashboard/PromoAlertBanner'
import { PWAUpdatePrompt } from './PWAUpdatePrompt'
import { InstallPrompt } from './InstallPrompt'
import { MigrationPrompt } from '@/components/auth/MigrationPrompt'
import { DemoModeBanner } from '@/components/auth/DemoModeBanner'

interface AppShellProps {
  children: ReactNode
  // user prop intentionally optional — null = local mode, object = SaaS mode
  user?: { name: string; email: string } | null
}

export function AppShell({ children, user = null }: AppShellProps) {
  const { banner } = usePromoAlerts()
  // v0.8.56 — pick up the other household member's changes on return.
  useRefreshOnFocus()

  return (
    <div className="min-h-screen bg-slate-950 flex flex-col">
      <Header user={user} />
      <DemoModeBanner />
      <MigrationPrompt />
      {banner.length > 0 && <PromoAlertBanner alerts={banner} />}
      <main
        className="flex-1 max-w-screen-2xl mx-auto w-full px-3 sm:px-4 py-4 sm:py-6 pb-24 md:pb-6"
        style={{ paddingBottom: 'max(env(safe-area-inset-bottom), 6rem)' }}
      >
        {children}
      </main>
      <BottomNav />
      <InstallPrompt />
      <PWAUpdatePrompt />
    </div>
  )
}
